// extracted by mini-css-extract-plugin
export default {"Box":"suggestions-for-repository-module__Box--VcqNz"};